module.exports = __webpack_public_path__ + "img/20200522-1.ec001663.png";